/**
 * Dónde está el servidor visto desde el navegador.
 *
 * Sin variables de entorno se asume el **mismo host que sirvió la página**, en el
 * puerto del servidor. Hardcodear `localhost` obligaba a escribir la IP del día en
 * un `.env` para poder abrir el dev server a la LAN: desde el teléfono,
 * `localhost` es el teléfono, y la página cargaba pero ni el login ni el join
 * encontraban backend.
 *
 * En producción cliente y servidor viven en dominios distintos, así que ahí se
 * declaran `VITE_API_URL` y `VITE_SERVER_URL` y esta derivación no se usa.
 */
const SERVER_PORT = 2567;

function sameHost(protocol: string): string {
  return `${protocol}//${window.location.hostname}:${SERVER_PORT}`;
}

const secure = window.location.protocol === "https:";

/** Base de la API HTTP transaccional: auth, tienda, sesiones de juego. */
export const API_URL: string = import.meta.env.VITE_API_URL ?? sameHost(secure ? "https:" : "http:");

/** Endpoint de Colyseus. */
export const SERVER_URL: string =
  import.meta.env.VITE_SERVER_URL ?? sameHost(secure ? "wss:" : "ws:");
